// extracted by mini-css-extract-plugin
module.exports = {"card":"Popup_card__2tmxx","msg":"Popup_msg__2GXG3","btn":"Popup_btn__15C88","main_popup":"Popup_main_popup__CSs-l","animDrop":"Popup_animDrop__2TguQ"};